enum LoanEmailsActionsEnum {
    LoanEmailsList = 'LOAN/EMAILS/LIST',
    LoanEmailsSet = 'LOAN/EMAILS/SET',
    LoanEmailTextGet = 'LOAN_EMAIL/TEXT/GET',
    LoanEmailTextSet = 'LOAN_EMAIL/TEXT/SET',
}

export default LoanEmailsActionsEnum;
